import { AgTechClickEventHandler, useClickable } from "../../components/Buttons/AgTechButtons";
import React, { useRef, useState } from "react";

export type AgTechIconBadgeProps = {
    icon: string,
    action?: (e: AgTechClickEventHandler) => Promise<void>,
    badgeClasses?: string,
    iconClasses?: string,
    styles?: React.CSSProperties,
    size?: number,
    rounded?: boolean
}

const AgTechIconBadge = (props: AgTechIconBadgeProps) => {
    const badgeRef = useRef<HTMLDivElement>(null);
    const badgeClickable = useClickable(badgeRef);

    let badgeStyles: React.CSSProperties = props.styles ?? {};

    if (props.size) {
        badgeStyles.height = props.size;
        badgeStyles.maxHeight = props.size;
        badgeStyles.width = props.size;
        badgeStyles.maxWidth = props.size;
        badgeStyles.minWidth = props.size;
    }

    if (props.rounded ?? false) {
        badgeStyles.borderRadius = badgeStyles.height;
    }

    let [isSubmitting, setIsSubmitting] = useState(false);

    const onClicked = async () => {
        setIsSubmitting(true);

        await props.action?.(badgeClickable.clickableRef.current!);

        setIsSubmitting(false);
    }

    return isSubmitting ? (
        <div
            className="loader"
            style={{
                height: 16,
                width: 16,
                borderWidth: 2
            }}
        />
    ) : (
        <div
            className={`stretched rounded border centered bg-slate-200 flex ${props.badgeClasses ?? ''}`}
            style={badgeStyles}
            onClick={props.action ? onClicked : undefined}
            ref={badgeRef}
        >
            <i className={`${props.icon} text-[100%] ${props.iconClasses}`} style={{ lineHeight: props.size }} />
        </div>
    )
}

export default AgTechIconBadge